<script lang="ts" setup></script>
<template>
  <svg width="72" height="48" viewBox="0 0 72 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="11" height="8" rx="2" fill="currentColor" />
    <rect x="13" width="11" height="8" rx="2" fill="currentColor" />
    <rect y="10" width="72" height="38" rx="3" fill="currentColor" />
  </svg>
</template>
